export class YasqeActionButtonDefinition {
    constructor(name, disabled) {
    }
}
